"use client";
import { jsx as c } from "react/jsx-runtime";
import { memo as e } from "react";
import i from "../components/Icon/SvgIcon.js";
const l = (o) => /* @__PURE__ */ c(
  i,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.252 19.997c.036.413.464.753.965.753h14.02c.502 0 .93-.34.966-.753l-1.118-5.202a.6.6 0 0 1-.014-.131c0-.437-.443-.808-.968-.808h-2.152a.6.6 0 0 1-.19-.038 59 59 0 0 1-2.38 3.61 1.416 1.416 0 0 1-2.307-.001 59 59 0 0 1-2.358-3.571H6.351c-.524 0-.968.371-.968.808a.6.6 0 0 1-.013.131zM16.92 7.942a4.7 4.7 0 0 0-4.693-4.692 4.7 4.7 0 0 0-4.692 4.692c0 1.473 1.704 4.747 4.558 8.761.082.117.186.116.268.001 2.855-4.015 4.559-7.289 4.559-8.762m3.4 6.649 1.121 5.22a.6.6 0 0 1 .014.13c0 1.135-.995 2.059-2.218 2.059H5.217C3.995 22 3 21.076 3 19.941q0-.066.013-.13l1.121-5.22c.042-1.101 1.021-1.985 2.217-1.985h1.641c-.966-1.747-1.707-3.475-1.707-4.664A5.95 5.95 0 0 1 12.227 2a5.95 5.95 0 0 1 5.943 5.942c0 1.189-.742 2.917-1.706 4.664h1.639c1.196 0 2.175.884 2.217 1.985m-9.692-6.977c0-.882.717-1.6 1.6-1.6a1.6 1.6 0 1 1-1.599 1.6m-1.25 0a2.853 2.853 0 0 0 2.85 2.848 2.853 2.853 0 0 0 2.848-2.848 2.853 2.853 0 0 0-2.849-2.85 2.853 2.853 0 0 0-2.849 2.85",
        clipRule: "evenodd"
      }
    )
  }
), n = e(l);
export {
  n as LocationSpecific,
  n as default
};
